/* Password dialog for the holding page.
 *
 * <dialog> is used rather than a hand-rolled overlay because showModal() gives
 * the focus trap, the inert background, Escape-to-close and the ::backdrop for
 * free — all of which would otherwise be code to write and get wrong.
 */
(function () {
  var dialog = document.getElementById('splash-login');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var opener = document.querySelector('[data-splash-open]');

  function open() {
    dialog.showModal();
    var field = dialog.querySelector('input[type="password"]');
    if (field) field.focus();
  }

  if (opener) opener.addEventListener('click', open);

  dialog.addEventListener('click', function (event) {
    /* A click on the backdrop is reported against the dialog itself, because
       the backdrop is a pseudo-element with no node of its own. Comparing the
       pointer against the dialog's own box is what separates the two. */
    if (event.target !== dialog) return;
    var box = dialog.getBoundingClientRect();
    var outside =
      event.clientX < box.left ||
      event.clientX > box.right ||
      event.clientY < box.top ||
      event.clientY > box.bottom;
    if (outside) dialog.close();
  });

  var closer = dialog.querySelector('[data-splash-close]');
  if (closer) closer.addEventListener('click', function () { dialog.close(); });

  /* A rejected password re-renders the whole page, so the dialog would come
     back closed with the error hidden inside it. */
  if (dialog.querySelector('[data-splash-error]')) open();
})();
